import React, { useContext, useEffect, useState } from "react";
import {
  IonButtons,
  IonButton,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonItem,
  IonLabel,
  IonInput,
  IonToast,
  IonText,
  IonPage,
  IonContent,
  IonCol,
  IonCard,
  IonCardContent,
  IonGrid,
  IonRow,
  IonSelect,
  IonSelectOption,
  IonAvatar,
  IonCardHeader,
  IonList,
  IonSpinner,
  IonIcon,
  IonBackButton,
  IonListHeader,
  IonLoading,
} from "@ionic/react";
import { useHistory } from "react-router";
import ExploreContainer from "../../components/ExploreContainer";

import * as ApiService from "../../services/ApiService";
import "./BillingReport.css";
import UsersComponent from "../../components/UsersComponent";
import {
  ApplicationContext,
  ProviderContext,
  ProviderContextProvider,
} from "../../ApplicationState";
import Header from "../../components/Header/Header";
import { addCircle, arrowBackCircleSharp, shareOutline } from "ionicons/icons";
import * as Helpers from "../../services/Helpers";
import saveAs from "save-as";
import { CloudDownloadSharp } from "react-ionicons";

const BillingReport: React.FC = (props: any) => {
  const { userState } = useContext(ApplicationContext);
  const [filteredReport, setFilteredReport] = React.useState([]);
  const [report, setReport] = React.useState([]);
  const [showLoading, setShowLoading] = useState(false);

  // Default to the current month (1-indexed: Jan = 1, Feb = 2...)
  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth() + 1);

  const months = [
    { value: 1, label: 'January' },
    { value: 2, label: 'February' },
    { value: 3, label: 'March' },
    { value: 4, label: 'April' },
    { value: 5, label: 'May' },
    { value: 6, label: 'June' },
    { value: 7, label: 'July' },
    { value: 8, label: 'August' },
    { value: 9, label: 'September' },
    { value: 10, label: 'October' },
    { value: 11, label: 'November' },
    { value: 12, label: 'December' },
  ];

  useEffect((): any => {
    if (userState.authenticatedUser !== undefined) {
      let isSubscribed = true;
      setShowLoading(true)
      const currentYear = new Date().getFullYear();
      console.log("currentYear ", currentYear)
      console.log("selectedMonth ", selectedMonth)
      console.log("selectedMonth ", `${String(selectedMonth).padStart(2, '0')}-01`)

      // Formats the selected month into a valid target date string (e.g., "2026-09-01")
      const targetDate = `${currentYear}-${String(selectedMonth).padStart(2, '0')}-01`;
      console.log("targetDate ", targetDate)

      ApiService.getPatientCountReport(userState.authenticatedUser, "table", targetDate)
        .then((data) => {
          console.log("getPatientCountReport ", data)
          setReport(data);
          setFilteredReport(data);
          setShowLoading(false)
        })
        .catch((err) => {
          setShowLoading(false)
          alert(err);
        });
      return () => (isSubscribed = false);
    }
  }, [userState, selectedMonth]);

  function downloadXls() {
    setShowLoading(true)
    const currentYear = new Date().getFullYear();
    console.log("currentYear ", currentYear)
    console.log("selectedMonth ", selectedMonth)
    console.log("selectedMonth ", `${String(selectedMonth).padStart(2, '0')}-01`)

    // Formats the selected month into a valid target date string (e.g., "2026-09-01")
    const targetDate = `${currentYear}-${String(selectedMonth).padStart(2, '0')}-01`;
    console.log("targetDate ", targetDate)
    ApiService.getPatientCountReport(userState.authenticatedUser, "xls", targetDate)
      .then((data) => {
        setShowLoading(false)
        const downloadedFile = Helpers.base64ToBlob(
          data.fileContents,
          data.contentType
        );
        const fileName = data.fileDownloadName || `Billing_Sheet_${new Date().toISOString()}.xlsx`;
        saveAs(downloadedFile, fileName);
      })
      .catch((err) => {
        setShowLoading(false)
        alert(err);
      });
  }

  function uploadXls() {
    setShowLoading(true)
    ApiService.uploadReport(userState.authenticatedUser, "xls")
      .then((data) => {
        setShowLoading(false)
        // const downloadedFile = Helpers.base64ToBlob(
        //   data.fileContents,
        //   data.contentType
        // );
        // const fileName = data.fileDownloadName || `Billing_Sheet_${new Date().toISOString()}.xlsx`;
        // saveAs(downloadedFile,fileName);
      })
      .catch((err) => {
        setShowLoading(false)
        alert(err);
      });
  }

  return (
    <IonPage>
      <Header />
      <IonHeader>
        <IonToolbar color="light">
          <IonButtons slot="start">
            <IonBackButton
              text="Go Back"
              icon={arrowBackCircleSharp}
              defaultHref="/"
            />
          </IonButtons>
          <IonTitle>
            Billing Report
          </IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent className="ion-padding">

        <IonRow>
          <IonItem>
            <IonCol>
              <IonItem>
                <IonLabel style={{ fontWeight: 'bold', marginRight: 10 }}>
                  Select Billing Month
                </IonLabel>
                <IonSelect
                  value={selectedMonth}
                  placeholder="Choose Month"
                  onIonChange={(e) => setSelectedMonth(Number(e.detail.value))}
                >
                  {months.map((m) => (
                    <IonSelectOption key={m.value} value={m.value}>
                      {m.label}
                    </IonSelectOption>
                  ))}
                </IonSelect>
              </IonItem>
            </IonCol>
          </IonItem>

          <IonItem className="col">
            <IonButton onClick={() => downloadXls()} slot="end">
              Xls&nbsp;&nbsp;&nbsp;
              <CloudDownloadSharp
                color={"#00000"}
                title="Download"
                height="15px"
                width="15px"
              />
            </IonButton>
            <IonButton onClick={() => uploadXls()} slot="end">
              Export to SFTP&nbsp;&nbsp;&nbsp;
              <IonIcon
                icon={shareOutline}
                color="dark"
                style={{ height: "15px", width: "15px" }}
                title="Export to SFTP"
              />
            </IonButton>
          </IonItem>
        </IonRow>
        <IonList>
          <IonListHeader color="primary">
            <IonLabel className="col-3">Provider Name</IonLabel>
            <IonLabel className="col-2">Code</IonLabel>
            <IonLabel className="col-2">Patient Count</IonLabel>
            <IonLabel className="col-2">Unit Price</IonLabel>
            <IonLabel className="col-2">Total Cost</IonLabel>
          </IonListHeader>
          {filteredReport?.map((a) => {
            return (
              <IonItem
                key={a.providerCode}
                button
                onClick={() => { }}
                lines="full"
              >
                <IonLabel className="col-3">{a.providerName}</IonLabel>
                <IonLabel className="col-2">
                  <i>{a.providerCode}</i>
                </IonLabel>
                <IonLabel className="col-2">
                  <i>{a.count}</i>
                </IonLabel>
                <IonLabel className="col-2">
                  <i>{a.unitPrice}</i>
                </IonLabel>
                <IonLabel className="col-2">
                  <i>{a.totalCost}</i>
                </IonLabel>
              </IonItem>
            );
          })}
        </IonList>
        <IonLoading
          cssClass="my-custom-class"
          isOpen={showLoading}
          onDidDismiss={() => setShowLoading(false)}
          message={"Please wait..."}
        />
        {/* <IonItem button routerLink={"/register"} routerDirection="none">Register New User</IonItem> */}
        {/* <UsersComponent type="Users" /> */}
      </IonContent>
    </IonPage>
  );
};

export default BillingReport;
